module.exports = __webpack_public_path__ + "static/media/logos_squares_Sup_HKCS.0dfd6bbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Sup_HKCS.png
// module id = 56
// module chunks = 0